import { render, staticRenderFns } from "./diyrichText.vue?vue&type=template&id=035fe41c&scoped=true&"
import script from "./diyrichText.vue?vue&type=script&lang=js&"
export * from "./diyrichText.vue?vue&type=script&lang=js&"
import style0 from "./diyrichText.vue?vue&type=style&index=0&id=035fe41c&lang=less&scoped=true&"
import style1 from "./diyrichText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035fe41c",
  null
  
)

export default component.exports